var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/virtualizedApp";
export default class VirtualizedAppService {
    static isPageAccessible(featureName) {
        return FetchService.get(BASE_URL + "/isPageAccessible", {
            featureName,
        });
    }
    static getInternalApps() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = FetchService.get("/aviso/virtualizedApp/search", {
                external: false,
            });
            // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'VirtualizedApp[]'.
            return response;
        });
    }
    static getInternalAppsByQuery(query) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse("/aviso/virtualizedApp/search", {
                query,
                external: false,
            });
        });
    }
    /**
     * Returns all internal apps and an app with an id of -1, to be used to select options for app search in
     * activity feed filters
     *
     * @returns {Promise<VirtualizedApp[]>} all internal apps and an app with an id of -1
     */
    static getInternalAppsAndNullOption() {
        // @ts-expect-error - TS2322 - Type 'Promise<unknown>' is not assignable to type 'Promise<VirtualizedApp[]>'.
        return FetchService.getSingleResponse("/aviso/virtualizedApp/search", {
            external: false,
        }).then((apps) => {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            apps.push({
                badgeColor: "secondary",
                createdBy: null,
                id: -1,
                displayName: "None",
                name: "none",
            });
            return apps;
        });
    }
    static getAppsForCurrentUser() {
        return FetchService.getSingleResponse("/aviso/virtualizedApp/virtualizedAppsForPerson/");
    }
    static getAppHomeUri(virtualizedAppName) {
        return FetchService.getSingleResponse("/aviso/virtualizedApp/getAppHomeUri/", {
            virtualizedAppName,
        });
    }
    static getNavigationFeaturesForPassedApp(virtualizedAppName) {
        return FetchService.getSingleResponse("/aviso/virtualizedApp/getNavigationFeatures/", { virtualizedAppName });
    }
    static search(search, options) {
        return FetchService.getSingleResponse("/aviso/virtualizedApp/search/", Object.assign(Object.assign({}, search), options));
    }
    static getAppsForFindPath(findPath, studentId, tabId) {
        return FetchService.getSingleResponse("/aviso/virtualizedApp/getAppsForFindPath", { findPath, studentId, tabId });
    }
}
